const $ = require('jquery')

const ajaxLoader = require('./ajaxLoader')
const { URL_API } = require('./api')
const { globals, Loader } = require('./globals')
const Overlay = require('./overlay')
const queryString = require('./queryString')

// =========================================================================
// Booking form
// =========================================================================
export const bookingForm = function(urlGet, urlPost, bookingFormObjValues, reinitFunction) {
  const formBooking = $('.form-booking')
  const hotelId = formBooking.find('input[name="HotelCode"]').val()
  const urlJson = `${URL_API.GetBookingWidgetOffer}?HotelCode=${hotelId}${urlGet}`
  const formBookingWrap = $('.offer-sidebar__form')
  const _formBookingErrMsg = $('.offer-sidebar__form__error-msg')
  const formBookingErrMsg = formBookingWrap.find('.offer-sidebar__form__error-msg')
  const formBookingBtn = formBookingWrap.find('.btn-booking')

  queryString.Get()

  ajaxLoader.init({
    devTest: true,
    url: urlJson,
    method: 'GET',
    type: 'bookingForm',
    placeholder: [ {
      elem: $('.offer-sidebar__header').find('.price-full'),
    }, {
      elem: $('.offer-sidebar__header').find('.price-person'),
    } ],
    beforeSendRequest () {
      Overlay.addTo(formBookingWrap, 'dark')
      formBooking.find('fieldset > div').filter('.open').removeClass('open')
      formBookingWrap.prepend(Loader('small', 'white'))
      $('.blockedOverlay').remove()

      $('.custom-select-room input:radio, .custom-select-food input:radio, .custom-select-airport input:radio, .custtom-select-date input:radio').each(function() {
        $(this).prop('disabled', false)
        $(this).removeAttr('disabled')
      })
    },
    callback (data) {
      if (data.errorMessage) {
        formBookingBtn.hide()

        if ($('.offer-sidebar__form__error-msg').length || formBookingErrMsg.parent().length) {
          formBookingErrMsg.fadeIn()
        } else {
          formBookingBtn.parent().append(`<span class="offer-sidebar__form__error-msg">${data.errorMessage}</span>`)
          formBookingErrMsg.fadeIn()
        }
      } else {
        const bookingUrl = `offercode=${data.Id}&HotelCode=${hotelId}${urlPost}`

        if (_formBookingErrMsg.exists()) {
          formBookingErrMsg.hide()
        }

        formBookingBtn.fadeIn()
        formBookingBtn.attr('href', `/rezerwacja?${bookingUrl}`)

        const updateQuery = function(key, container) {
          const variableName = key
          if (window.location.href.indexOf(key.toLowerCase()) != -1) {
            key = key.toLowerCase()
          }
          queryString.Update(key, container[variableName])
        }

        for (let i = 1; i <= bookingFormObjValues.Children; i++) {
          updateQuery(`Child${i}`, bookingFormObjValues)
        }
        queryString.Update('offercode', data.Id)
        updateQuery('Adults', bookingFormObjValues)

        if (bookingFormObjValues.Children != null && bookingFormObjValues.Children != undefined) {
          updateQuery('Children', bookingFormObjValues)
        }
      }
    },
    afterSuccess (data) {
      Overlay.removeFrom(formBookingWrap)
      formBookingWrap.find('.loader__inner').remove()

      const roomCode = data.Rooms
      if (roomCode) {
        formBooking.find('.custom-select-room').find(`input[value="${roomCode.Value}"]`).prop('checked', true)
        const value = $.trim(formBooking.find('.custom-select-room input[type=radio]:checked').next('label').html())
        formBooking.find('.custom-select-room').find('.section-title').html(value)
      }

      if (!data.AlternativeOffers) {
        $('.custom-select-room input:radio, .custom-select-food input:radio, .custom-select-airport input:radio, .custom-select-date input:radio').each(function() {
          $(this).prop('disabled', true)
        })
        reinitFunction(true)
        return
      }

      $('.custom-select-room .list-elements').empty()
      $('.custom-select-food .list-elements').empty()
      $('.custom-select-airport .list-elements').empty()

      const roomCodes = data.AlternativeOffers.Rooms
      const foodCodes = data.AlternativeOffers.Foods
      const airports = data.AlternativeOffers.Flights

      roomCodes.forEach(function(e) {
        let inputText = `<input id="Rooms${e.Value}" name="Rooms" type="radio" value="${e.Value}"`
        if (e.Selected) { inputText = `${inputText} checked` }
        if (!e.Enabled) { inputText = `${inputText} disabled="disabled"` }
        inputText = `${inputText}>`
        $('.custom-select-room .list-elements').append(`
          <div class="radio">
            ${inputText}
            <label for="Rooms${e.Value}">${e.Text}</label>
          </div>
        `)
      })

      foodCodes.forEach(function(e) {
        let inputText = `<input id="Food${e.Value}" name="BoardStandards" type="radio" value="${e.Value}"`
        if (e.Selected) { inputText = `${inputText} checked` }
        if (!e.Enabled) { inputText = `${inputText} disabled="disabled"` }
        inputText = `${inputText}>`

        $('.custom-select-food .list-elements').append(`
          <div class="radio">
            ${inputText}
            <label for="Food${e.Value}">${e.Text}</label>
          </div>
        `)
      })

      airports.forEach(function(e) {
        let selectedString = ''
        const flightTimeSep = e.FlightTime.length ? ' / ' : ''
        const returnFlightTimeSep = e.ReturnFlightTime.length ? ' / ' : ''

        if (e.Selected) { selectedString = ' checked' }
        $('.custom-select-airport .list-elements').append(`
          <div class="option">
            <div class="airportSelected hidden">
              <div class="departure">${e.FlightFrom + flightTimeSep + e.FlightTime}</div>
              <div class="arrival">${e.ReturnFlightTo + returnFlightTimeSep + e.ReturnFlightTime}</div>
            </div>
            <div class="radio">
              <input id="Airport${e.FlightCode}" name="Airports" type="radio" value="${e.FlightCode}"${selectedString}>
              <input id="ReturnAirport${e.FlightCode}" name="ReturnAirport" type="radio" value="${e.ReturnFlightCode}"${selectedString}>
              <label for="Airport${e.FlightCode}">
                <span class="filter-airports--infomations">
                  <span class="departure">${e.FlightFrom + flightTimeSep + e.FlightTime}</span>
                  <span class="arrival">${e.ReturnFlightTo + returnFlightTimeSep + e.ReturnFlightTime}</span>
                </span>
              </label>
              </div>
            </div>
          </div>
        `)
      })

      globals.updateValueCallback(formBooking, data.Id)

      reinitFunction(true)
    },
  })
}




// WEBPACK FOOTER //
// ./src/modules/bookingForm.js